export const SET_TABLE_DETAILS = 'SET_TABLE_DETAILS'
export const SET_TABLE_VIEW_TYPE = 'SET_TABLE_VIEW_TYPE'